var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('top-header'),_vm._v(" "),_c('left-menu'),_vm._v(" "),_c('div',{staticClass:"rightcontent",class:{hideSidebars:_vm.isCollapse}},[_c('div',{staticClass:"contents"},[_c('bread-crumb'),_vm._v(" "),_c('el-main',[_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[_c('router-view')],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249c0185","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = null
// module chunks = 